/**********************************************************
 * 
 *  Error Variables
 *  
 **********************************************************/

const standardErrorMessage = {
    title : 'Uh Oh..',
    details : 'Something broke on our end. Try refreshing the panel or contacting us.',
    type : 'warning'
};

const errors = {
    // Dashboard - Orders
    'orders' : {
        'Request Error' : {
            title : 'Uh Oh..',
            details : 'Something broke on our end. Try refreshing the panel or contacting us.',
            type : 'warning'
        },
        'Unauthorized Request' : {
            title : 'Unauthorized - Sorry',
            details : 'Login and then check back here to see your orders.',
            type : 'warning'
        },
        'Key Retrieval Error' : {
            title : 'No Api Keys Available', 
            details : 'Check out the Api Keys page to see analytics from your exchanges.',
            type : 'warning'
        },
        'Final' : {
            title : 'Sorry About Your Orders',
            details : 'We\'re working hard to squash bugs like these. Try refreshing the page or contacting us.',
            type : 'warning'
        }
    },
    // Dashboard - Positions
    'positions' : {
        'Request Error' : {
            title : 'Uh Oh..',
            details : 'Something broke on our end. Try refreshing the panel or contacting us.',
            type : 'warning'
        },
        'Unauthorized Request' : {
            title : 'Unauthorized - Sorry',
            details : 'Login and then check back here to see your orders.',
            type : 'warning'
        },
        'Key Retrieval Error' : {
            title : 'No Api Keys Available', 
            details : 'You might be up big right now. Or on the brink of liquidation. Add some keys if you want to find out..',
            type : 'warning'
        },
        'Final' : {
            title : 'Sorry About Your Positions',
            details : 'We\'re working hard to squash bugs like these. Try refreshing the page or contacting us.',
            type : 'warning'
        }
    },
    // Dashboard - HistPnl
    'histpnl' : {
        'Request Error' : {
            title : 'Uh Oh..',
            details : 'Something broke on our end. Try refreshing the panel or contacting us.',
            type : 'warning'
        },
        'Unauthorized Request' : {
            title : 'Unauthorized - Sorry',
            details : 'Login and then check back here to see your historical pnl.',
            type : 'warning'
        },
        'No Historical Pnl' : {
            title : 'No Historical Data Yet', 
            details : "Come back tomorrow to see your first day's pnl per coin.",
            type : 'warning'
        }
    }
}



/**********************************************************
 * 
 *  Error Handler's for specifc components within the app.
 *  Given a raw error message, format and return it
 *  
 **********************************************************/

// Given an error, check if it is an object and that it has proper fields for parsing
function validateErrorObject(error) {

    try {

        // 1. check if error is an object
        if(typeof error === 'object') {

            // 2. check for data and message fields
            if(error.hasOwnProperty('data') && error.hasOwnProperty('message'))
                return true;
            else
                return false;
        }
        else {
            return false;
        }

    }
    catch(error) {

        return false;

    }

}

// Given the app location and the error, return the properly formatted translation
function parseError(location, error) {

    try {

        if(validateErrorObject(error)) {

            // Check errors by data field and message field
            for(let[errorType, message] of Object.entries(errors[location])) {

                // data field
                if(errorType == error.data)
                    return errors[location][errorType];

                // message field
                //if(error.message.includes())
            }

            return errors[location]['Final'];

        }
        else {
            return standardErrorMessage;
        }

    }
    catch(error) {
        return {
            title : 'Double Error',
            details : "Yes thats right. It's an error from parsing an error.",
            type : 'error'
        }
    }

}


// Dashboard - Historical PnL
function historicalPnlError(error) {

    var msg = {
        title : 'Uh Oh..',
        details : 'Something broke on our end. Try refreshing the panel or contacting us.',
        type : 'warning'
    };

    if(Object.keys(error).length > 0) {

        if(error.message.includes("exist in the historical db")) {
            msg = {
                title : 'No Api Keys Available', 
                details : 'See your daily profit and loss from the last week, right here.',
                type : ''
            };
        }
        else if(error.message.includes("no historical pnl")) {
            msg = {
                title : 'No Historical Data Yet', 
                details : "Come back tomorrow to see your first day's total pnl.",
                type : 'warning'
            };
        }
        
    }

    return msg;

}

// Dashboard - Currency History
function currencyHistoryError(error) {

    var msg = {
        title : 'Uh Oh..',
        details : 'Something broke on our end. Try refreshing the panel or contacting us.',
        type : 'warning'
    };

    if(Object.keys(error).length > 0) {

        if(error.message.includes("exist in the historical db")) {
            msg = {
                title : 'No Api Keys Available', 
                details : 'Add Api Keys to see your total profit per coin, over time.',
                type : ''
            };
        }
        else if(error.message.includes("no historical pnl")) {
            msg = {
                title : 'No Historical Data Yet', 
                details : "Come back tomorrow to see your first day's pnl per coin.",
                type : 'warning'
            };
        }
        
    }

    return msg;

}


const ErrorHandler = { parseError, historicalPnlError, currencyHistoryError };
export default ErrorHandler;


// WEBPACK FOOTER //
// ./src/Utils/ErrorHandler.js